import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import DatePicker from 'components/inputs/DatePicker';
import './_dateRangePicker.scss';

type Props = {
    onChange: (arg1: string) => void;
    disabled?: boolean;
    start: string;
    end: string;
    shouldDebounce: boolean;
};

export default function DateRangePicker(props: Props): React.ReactElement {
    const { t } = useTranslation();
    const { start, end, disabled } = props;

    return (
        <div className="date-range-picker">
            <DatePicker
                disabled={disabled}
                value={start}
                onChange={(inputDate) => props.onChange(`${inputDate}|${end}`)}
                shouldDebounce={props.shouldDebounce}
                InputProps={{ disableUnderline: true }}
            />
            <Typography className="no-flex-shrink">
                {t('sentence:filterLinker.andThe')}
            </Typography>

            <DatePicker
                disabled={disabled}
                value={end}
                onChange={(inputDate) =>
                    props.onChange(`${start}|${inputDate}`)
                }
                shouldDebounce={props.shouldDebounce}
                InputProps={{ disableUnderline: true }}
            />
        </div>
    );
}
